import React from "react";
import { WhmBox, WhmTypography } from "@securitize/reactjs-whm";
import { AssetWithPosition } from "../../../data/types/portfolio-statement/portfolio-statement";
import { useAssetOrdering } from "../../../hooks/useAssetOrdering";
import { AssetSelectionItem } from "./AssetSelectionItem";
import { translationKeys } from "../../../hooks/useTranslation";
import { Translate } from "../../shared/translation";

interface AssetSelectionListProps {
  assets: AssetWithPosition[];
  isSelected: (assetId: string) => boolean;
  toggleAsset: (assetId: string) => void;
}

export const AssetSelectionList: React.FC<AssetSelectionListProps> = ({
  assets,
  isSelected,
  toggleAsset,
}) => {
  const { orderedAssets } = useAssetOrdering(assets);

  return (
    <WhmBox sx={{ mb: 3 }}>
      <WhmTypography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
        <Translate
          translationKey={
            translationKeys.PORTFOLIO_STATEMENT_INCLUDED_TOKENS_TITLE
          }
        />
      </WhmTypography>

      <WhmTypography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        <Translate
          translationKey={
            translationKeys.PORTFOLIO_STATEMENT_INCLUDED_TOKENS_SUBTITLE
          }
        />
      </WhmTypography>

      {orderedAssets.map((asset) => (
        <AssetSelectionItem
          key={asset.id}
          asset={asset}
          isSelected={isSelected(asset.id)}
          onToggle={toggleAsset}
        />
      ))}
    </WhmBox>
  );
};
